import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SecurityService } from '../security.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  displayErrorMessage: boolean = false;

  constructor(private securityService: SecurityService) { }

  ngOnInit() {
  }


  private createNewNamecheapAccount(formData: NgForm) {
    
    


  }
}
